import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class FinalStep extends _BaseUserProfile {
  component = 'UserProfileFinishedForm';
}
